import { render } from "./combination-outcome.vue?vue&type=template&id=f3d6be8e&scoped=true"
import script from "./combination-outcome.vue?vue&type=script&lang=js"
export * from "./combination-outcome.vue?vue&type=script&lang=js"

import "./combination-outcome.vue?vue&type=style&index=0&id=f3d6be8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d6be8e"]])

export default __exports__